export const ACTIONS = {
  FETCH_DATA_LOADING: 'FETCH_DATA_LOADING',
  FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
  FETCHED_PRODUCTS_BY_CATEGORY: 'FETCHED_PRODUCTS_BY_CATEGORY',
  FETCH_PRODUCTS_FAILURE: 'FETCH_PRODUCTS_FAILURE',
  FETCH_SALES_SUCCESS: 'FETCH_SALES_SUCCESS',
  FETCHED_SALES_BY_DATE: 'FETCH_SALES_BY_DATE',
  FETCH_SALES_FAILURE: 'FETCH_SALES_FAILURE',
  ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
  ADD_PRODUCT_FAILURE: 'ADD_PRODUCT_FAILURE',
  UPDATE_PRODUCT_SUCCESS: 'UPDATE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_FAILURE: 'UPDATE_PRODUCT_FAILURE',
  DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_FAILURE: 'DELETE_PRODUCT_FAILURE',
  ADD_SALES_SUCCESS: 'ADD_SALES_SUCCESS',
  ADD_SALES_FAILURE: 'ADD_SALES_FAILURE',
  DELETE_SALES_SUCCESS: 'DELETE_SALES_SUCCESS',
  DELETE_SALES_FAILURE: 'DELETE_SALES_FAILURE'
};
